module.exports = __webpack_public_path__ + "static/media/about_us_owner_aresh.8959ce4b.jpg";